export const PREFIX_URL = '/publico';
export const generateURL = (url: string) => `${PREFIX_URL}${url}`;
